import { type PropsWithChildren } from "react"
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "~/components/reusable/hovercard/HoverCard"
import { formatNumber } from "~/utils/formatting"

type Props = PropsWithChildren & {
  value: number
  collectionName?: string
  inCollection: boolean
}

export default function ComparisonCollectionHoverCard({
  children,
  value,
  collectionName,
  inCollection,
}: Props) {
  return (
    <HoverCard>
      <HoverCardTrigger asChild>
        <div className="flex items-center w-full cursor-default">{children}</div>
      </HoverCardTrigger>
      <HoverCardContent
        className="w-64 p-0 overflow-hidden divide-y divide-border-base"
        align="start"
        side="right"
        sideOffset={8}
        avoidCollisions={true}
      >
        <div className="px-3 py-2 bg-subtle flex items-center gap-2">
          <span className="label-base text-fg-base">
            {inCollection ? "Comparison collection" : "Not in comparison"}
          </span>
        </div>
        {inCollection ? (
          <div className="px-3 py-2 flex items-center justify-between">
            <span className="paragraph-sm text-fg-subtle">{collectionName ?? "Comparison"}</span>
            <span className="paragraph-sm font-medium text-fg-base">{formatNumber(value, 0)}</span>
          </div>
        ) : (
          <div className="px-3 py-2">
            <p className="paragraph-sm text-fg-subtle">
              This variant is not in the comparison collection.
            </p>
          </div>
        )}
      </HoverCardContent>
    </HoverCard>
  )
}
